import Text from "common/Typography/Text";
import { CSSProperties } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

interface ExtraQuotaTextProps {
  extraQuota?: number;
  textStyle?: CSSProperties;
}

const ExtraQuotaText = ({ extraQuota, textStyle }: ExtraQuotaTextProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  if (!extraQuota) return null;

  return (
    <Text style={{ display: "inline", marginLeft: 4, ...textStyle }}>
      (+{extraQuota} {t("quota_modal.additional_quota")})
    </Text>
  );
};

export default ExtraQuotaText;
